import { TableHeadersType } from "../../tableHeadersType";

export const BALANCE_SHEET_HEADERS: TableHeadersType[] = [
  {
    label: 'Ledger Name',
    value: 'ledger_name',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Closing Amount',
    value: 'closing_amount',
    checked: true,
    defaultChecked: true
  }
]

export const BALANCE_SHEET_STOCK_SUMMARY_HEADERS:TableHeadersType[]=[
  {
    label: 'STOCK NAME',
    value: 'ledger_name',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Closing Amount',
    value: 'closing_amount',
    checked: true,
    defaultChecked: true
  }
]